import { useState } from "react";

import {
  COMPANY_CARD_STATUS,
  MenuAnchorEl,
  ROUTES,
} from "../../../../../../../../shared";
import { MORE_ACTIONS_MENU_SIZES } from "../../../../../../../../shared/components/buttons/types";
import { CompanyCardDto, DetailsDataType } from "../../../../../../types";
import SingleDetailsAcordionItem from "../../../AccordionDetailsCard/components/SingleDetailsAcordionItem";

import CompanyCardActions from "./CompanyCardActions/CompanyCardActions";
import CompanyCardContent from "./CompanyCardContent/CompanyCardContent";

interface SingleCompanyCardProps {
  totalCount: number;
  cardData: CompanyCardDto;
  index: number;
  companyData: DetailsDataType;
  canManageCompanyCards: boolean;
}

const SingleCompanyCard = ({
  totalCount,
  cardData,
  index,
  companyData,
  canManageCompanyCards,
}: SingleCompanyCardProps) => {
  const [isActionsOpen, setIsActionsOpen] = useState<MenuAnchorEl>(null);

  return (
    <SingleDetailsAcordionItem
      route={ROUTES.Companies}
      cardData={cardData}
      title={cardData.name}
      totalCount={totalCount}
      index={index}
      collapsable
      companyCardStatus={cardData.status as COMPANY_CARD_STATUS}
      anchorEl={isActionsOpen}
      setIsActionsOpen={setIsActionsOpen}
      titleInlineActions={
        canManageCompanyCards && (
          <CompanyCardActions
            cardData={cardData}
            companyData={companyData}
            onActionsMenu={setIsActionsOpen}
          />
        )
      }
      menuWidth={MORE_ACTIONS_MENU_SIZES.Small}
    >
      <CompanyCardContent cardData={cardData} />
    </SingleDetailsAcordionItem>
  );
};

export default SingleCompanyCard;
